/* eslint-disable consistent-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { Badge, Stack } from '@mui/material';
import { ReadNotification } from 'store/api/notification.api';
import { useSelector, useDispatch } from 'store';
import ImdaButton from 'components/button';
import CheckIcon from '@mui/icons-material/Check';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import CloseIcon from '@mui/icons-material/Close';
import { formatDateTime } from 'utils/application.helpers';
import { useNavigate } from 'react-router-dom';
import { updateOnEdit } from 'store/slices/application.slice';
import { deleteNotification, getNotification } from 'store/slices/notification';
import { setSelectedCaseID } from 'store/slices/dashboard';

export default function NotificationList() {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const {
        account: { user = {} } = {},
        dashboard: { cases = [], completedLicences = [], licences = [], completedLicencesStatus = '', lincenceStatus = '' } = {}
    } = useSelector(({ account, dashboard }) => ({
        account,
        dashboard
    }));

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { notificationData } = useSelector((state) => state.notification);

    const countRead = notificationData?.filter((data: { [key: string]: string }) => data.ReadReceipt === 'Unread');

    const handleReadNotification = async (pyGUID: string, isRead: boolean) => {
        if (isRead) return null;
        const response = await ReadNotification(
            pyGUID,
            new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'numeric', day: 'numeric' }),
            'false',
            'Read'
        );
        if (response === 200 && !isRead) dispatch(getNotification());
    };

    const handleDeleteNotification = async (pyGUID: string, index: number) => {
        const response = await ReadNotification(
            pyGUID,
            new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'numeric', day: 'numeric' }),
            'true',
            'Read'
        );

        if (response === 200) {
            dispatch(deleteNotification(index));
        }
    };

    const findCase = (caseID: string, caseType: string) => {
        // Attempt to find in the cases array
        let foundCase = cases.find((value) => value.caseid === caseID || value.applicationNumber === caseID);

        if (!foundCase && caseType === 'LICApplication') {
            foundCase = completedLicences.find((value) => value.caseid === caseID || value.applicationNumber === caseID);
        }

        if (!foundCase && caseType === 'Licence') {
            foundCase = licences.find((value) => value.caseid === caseID || value.applicationNumber === caseID);
        }

        return foundCase || {};
    };

    const handleRedirectNotification = async (
        notificationCategory: string,
        isRead: boolean,
        pyGUID: string,
        caseID: string,
        caseType: string
    ) => {
        const { pzInsKey = '', pxObjClass = '', ApplicationType = '', caseid = '' } = findCase(caseID, caseType) as Record<string, string>;

        if (!isRead) {
            handleReadNotification(pyGUID, isRead);
        }

        switch (caseType) {
            case 'LICApplication':
                dispatch(
                    updateOnEdit({
                        caseTypeID: pzInsKey ?? '',
                        application: pxObjClass ?? '',
                        applicationType: ApplicationType ?? '',
                        step: null,
                        isPreviewPage: true
                    })
                );

                dispatch(setSelectedCaseID(caseID));
                navigate(`/my-applications/${encodeURIComponent(caseid)}#messages`);
                return navigate(0);

            case 'Licence':
                dispatch(
                    updateOnEdit({
                        caseTypeID: pzInsKey ?? '',
                        application: pxObjClass ?? '',
                        applicationType: ApplicationType ?? '',
                        step: null,
                        isPreviewPage: true
                    })
                );

                dispatch(setSelectedCaseID(caseID));
                navigate(`/my-licences/${encodeURIComponent(caseid)}#messages`);
                break;

            default:
                dispatch(
                    updateOnEdit({
                        caseTypeID: pzInsKey ?? '',
                        application: pxObjClass ?? '',
                        applicationType: ApplicationType ?? '',
                        step: null,
                        isPreviewPage: true
                    })
                );
                navigate(`/my-applications/${encodeURIComponent(caseid)}#messages`);
                return navigate(0);
        }
    };

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <Tooltip title="View Notification">
                <IconButton
                    onClick={handleClick}
                    size="small"
                    sx={{ color: '#432055' }}
                    aria-controls={open ? 'notification-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                >
                    <Badge
                        color="error"
                        sx={{
                            '& .MuiBadge-anchorOriginBottomRightRectangular': {
                                background: 'red'
                            }
                        }}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        badgeContent={countRead?.length}
                    >
                        <NotificationsIcon />
                    </Badge>
                </IconButton>
            </Tooltip>
            <Menu
                anchorEl={anchorEl}
                id="notification-menu"
                open={open}
                onClose={handleClose}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflowY: 'auto',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        '& .MuiAvatar-root': {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1
                        },
                        width: 350,
                        maxHeight: 350,
                        '&:before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: 'background.paper',
                            transform: 'translateY(-50%) rotate(45deg)'
                        }
                    }
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                {notificationData?.length > 0 &&
                    notificationData?.map((notification: any, index: number) => {
                        const lastItem = index + 1;
                        const date = formatDateTime(notification?.pxCreateDateTime, true);
                        const isRead = Boolean(notification.ReadReceipt === 'Read');
                        const isReadHeader = isRead ? 'Read Message:' : 'New Message:';
                        return (
                            <MenuItem
                                key={`${notification.pyID}-${index}`}
                                sx={{
                                    whiteSpace: 'unset',
                                    wordBreak: 'break-all',
                                    borderBottom: lastItem === notificationData.length ? '0px' : '1px solid #EDEDED',
                                    width: '100%'
                                }}
                                onClick={() =>
                                    handleRedirectNotification(
                                        notification.pyCategory,
                                        isRead,
                                        notification.pyGUID,
                                        notification.pyID,
                                        notification.pyCaseType
                                    )
                                }
                            >
                                <Stack direction="column" flexWrap="wrap">
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                        {!isRead ? (
                                            <FiberManualRecordIcon sx={{ fontSize: '12px', marginTop: '3px', color: '#A5141D' }} />
                                        ) : (
                                            <IconButton
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                    handleDeleteNotification(notification.pyGUID, index);
                                                }}
                                                sx={{ height: 'fit-content', padding: '0px', marginTop: '4px' }}
                                            >
                                                <CloseIcon sx={{ fontSize: '12px', color: '#332C36' }} />
                                            </IconButton>
                                        )}
                                        <Box sx={{ flexDirection: 'column', width: '93%' }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <Typography variant="h5" sx={{ color: isRead ? '#83818480' : '#332C36' }}>
                                                    <b>{isReadHeader}</b>
                                                </Typography>
                                                <Typography variant="body2" sx={{ color: '#838184' }}>
                                                    {date}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <Typography
                                                    variant="body2"
                                                    sx={{ width: '80%', color: isRead ? '#332C3680' : '#555555', wordBreak: 'break-word' }}
                                                >
                                                    {notification.pyMessage}
                                                </Typography>
                                                {!isRead && (
                                                    <Tooltip title="Read Notification">
                                                        <Box sx={{ height: 'fit-content' }}>
                                                            <ImdaButton
                                                                sx={{ padding: '0px', minWidth: '30px', height: '30px', zIndex: 2 }}
                                                                onClick={(event) => {
                                                                    event.stopPropagation();
                                                                    handleReadNotification(notification.pyGUID, isRead);
                                                                }}
                                                            >
                                                                <CheckIcon sx={{ fontSize: '18px' }} />
                                                            </ImdaButton>
                                                        </Box>
                                                    </Tooltip>
                                                )}
                                            </Box>
                                        </Box>
                                    </Box>
                                </Stack>
                            </MenuItem>
                        );
                    })}
                {notificationData?.length === 0 && (
                    <MenuItem
                        sx={{
                            whiteSpace: 'unset',
                            wordBreak: 'break-all',
                            '&.hover': {
                                bgcolor: 'background.paper'
                            }
                        }}
                    >
                        <Typography sx={{ width: '100%' }}>You have no Notifications</Typography>
                    </MenuItem>
                )}
            </Menu>
        </>
    );
}
